import type { IconProps } from "@/types/icon";

const PlusIcon24 = ({
    width = 24,
    height = 24,
    fill = "#F2F2F2",
    ...remainingProps
}: IconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        {...remainingProps}
    >
        <path
            d="M6.34315 12.3236L17.6569 12.3236M12 6.66675L12 17.9805"
            stroke={fill}
            strokeWidth="2.66667"
            strokeLinecap="square"
            strokeLinejoin="round"
        />
    </svg>
);

export default PlusIcon24;
